module.exports = __webpack_public_path__ + "img/setor-branco.38ee73bb.png";